// M16 T15/T21 — AI kontrolü + form ↔ KPI tutarlılığı kopya metinleri (RK36 tek kaynak; KPI_COPY'ye
// alt anahtar olarak bağlanır).
import type { KpiAiCheckKey, KpiAiWarningRule } from "@mahir/shared";

export const KPI_CHECKS_COPY = {
  aiTitle: "AI Kontrolü",
  aiRun: "AI Kontrolü Çalıştır",
  aiRunning: "Kontrol ediliyor…",
  aiNever: "Henüz kontrol çalıştırılmadı.",
  aiLast: "Son kontrol",
  aiWarnings: "Uyarılar",
  aiNoWarnings: "Uyarı yok.",
  aiFailed: "AI kontrolü tamamlanamadı",
  checklist: {
    required_fields: "Zorunlu alanlar",
    formula_applied: "Formüller uygulandı",
    unit_check: "Birim kontrolü",
    period_check: "Dönem kontrolü",
    anomaly_scan: "Anomali taraması",
    evidence_check: "Kanıt kontrolü",
  } satisfies Record<KpiAiCheckKey, string>,
  rules: {
    unit_mismatch: "Birim uyuşmazlığı",
    anomaly_jump: "Sıçrama",
    zero_denominator: "Payda sıfır",
    missing_ref: "Girdi eksik",
    evidence_mismatch: "Kanıt uyuşmazlığı",
    unit_template_unresolved: "Birim şablonu çözülemedi",
    breakdown_mismatch: "Grup toplamı uyuşmuyor",
    legacy_metric_children: "Grupsuz alt satırlar",
  } satisfies Record<KpiAiWarningRule, string>,
  formTitle: "Form ↔ KPI uyuşmazlıkları",
  formNone: "Form yanıtlarıyla KPI tablosu uyumlu.",
  formHint: (year: number, value: string): string => `KPI tablosunda ${year}: ${value}`,
  formOnlyForm: (year: number, value: string): string =>
    `Form yanıtı ${value} — KPI tablosunda ${year} boş`,
  useKpi: "KPI değerini kullan",
  writeToKpi: "KPI tablosuna yaz",
  writeToForm: "Forma yaz",
  openForm: "Formu aç",
  formValue: "form",
  kpiValue: "KPI",
  // Finar 14.4 (K4) — soru ↔ gösterge birim/tip kapısı (sıra: gösterge birimi ↔ soru birimi)
  unitless: "birimsiz",
  unitMismatchHint: (kpiUnit: string, questionUnit: string): string =>
    `Birimler uyuşmuyor (${kpiUnit} ↔ ${questionUnit}) — bağ Veri Yönetimi'nde düzeltilmeli`,
  unitMismatchRow: (kpiUnit: string, questionUnit: string): string =>
    `bağ hatalı — birimler uyuşmuyor (${kpiUnit} ↔ ${questionUnit}); Veri Yönetimi'nde bağı düzeltin`,
  converted: (from: string, to: string): string => `çevrildi: ${from} → ${to}`,
  // Hücre editörü — form yanıtını KPI hücresine al (FORM rozetiyle aynı eylem, onaylı)
  editorFormValue: (value: string): string => `Form yanıtı: ${value}`,
  editorTakeForm: "Form yanıtını al",
  editorConfirm: (value: string): string => `KPI hücresine ${value} yazılsın mı?`,
  editorConfirmYes: "Evet, yaz",
  editorConfirmNo: "Vazgeç",
  editorFailed: "Form yanıtı KPI tablosuna yazılamadı",
} as const;
